<template>
    <!-- MenuBar.vue -->
    <nav class="menu-container2">
      <router-link
        v-for="(item, index) in menuItems"
        :key="index"
        :to="item.path"
        class="menu-item"
        active-class="active"
        exact-active-class="exact-active"
      >
        {{ item.name }}
      </router-link>
    </nav>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  // 菜单配置项
  const menuItems = ref([
  { name: '积分总榜', path: '/' },
  { name: '累计战神榜', path: '/allpage' },
  { name: '累计狂人榜', path: '/winpage' },
  { name: '年度战神榜', path: '/yearpage' },
  { name: '年度狂人榜', path: '/yearwinpage'},
  { name: '地区排行榜', path: '/areapage'},
  { name: '胜率排行榜', path: '/winratepage'},
  { name: 'U18排行榜', path: '/uneighteenpage'},
  { name: 'U14排行榜', path: '/unfourteenpage'},
  { name: '不活跃棋手', path: '/inactivepage'}
])
  </script>
  
  <style scoped>
  .menu-container2 {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    z-index:1;
  }
  
  .menu-item {
    height: 3rem;
    font-size:14px;
    text-align:center;
    padding: 12px 18px;
    list-style: none;
    text-decoration: none;
    transition: all 0.3s ease;
    border-radius:5px;
  }
  
  /* .menu-item:hover {
    background: #e0e0e0;
  }
   */
  /* 精确匹配时的样式 */
  .menu-item.exact-active {
    color: #fff;
    /* border-bottom: 2px solid #ebebeb; */
    background-color:#3378eb;
  }
  
  /* 非精确匹配时的激活状态（嵌套路由） */
  .menu-item.active:not(.exact-active) {
    color: #2196f3;
    font-weight: bold;
  }
  </style>